package dev.lingvo.site.components.studio.editor

import dev.lingvo.shared.screenshots.doc.BackgroundLayer
import dev.lingvo.shared.screenshots.doc.LayerPatch
import dev.lingvo.shared.screenshots.doc.TextLayer
import dev.lingvo.shared.screenshots.render.effectiveLocaleOverride

/** Locale opt-in covers keyboard and properties alike; unsupported fields cannot leak into shared layers. */
internal fun StageController.applyStudioProperty(ids: Set<String>, property: LayerProperty, label: String) {
    if (!uiState.editable) return
    var next = history.document
    for (id in ids) {
        val path = pathTo(uiState.layers, id)
        val layer = path.lastOrNull() ?: continue
        val localized = effectiveLocaleOverride(uiState.page, uiState.view.locale, uiState.document.schemaVersion)?.patches?.containsKey(id) == true
        if (localized && (path.any { it.base.locked } || layer is BackgroundLayer)) continue
        if (!localized) {
            next = commands.property(setOf(id), property).apply(next)
            continue
        }
        val patch = uiState.page.overrides[uiState.view.locale]?.patches?.get(id) ?: LayerPatch()
        val changed = when (property) {
            is LayerProperty.Hidden -> patch.copy(hidden = property.value)
            is LayerProperty.Fit -> {
                require(layer is TextLayer)
                patch.copy(fit = property.value)
            }
            is LayerProperty.Text -> {
                require(layer is TextLayer)
                val before = layer.style
                val after = property.value
                require(before.copy(family = after.family, weight = after.weight, align = after.align,
                    lineHeight = after.lineHeight, letterSpacingEm = after.letterSpacingEm) == after) {
                    "This text property is shared across languages" // i18n-ignore: controller replaces refusal with localized edit error
                }
                patch.copy(
                    family = if (before.family != after.family) after.family else patch.family,
                    weight = if (before.weight != after.weight) after.weight else patch.weight,
                    align = if (before.align != after.align) after.align else patch.align,
                    lineHeight = if (before.lineHeight != after.lineHeight) after.lineHeight else patch.lineHeight,
                    letterSpacingEm = if (before.letterSpacingEm != after.letterSpacingEm) after.letterSpacingEm else patch.letterSpacingEm,
                )
            }
            else -> throw IllegalArgumentException("This layer property is shared across languages") // i18n-ignore: controller replaces refusal with localized edit error
        }
        next = commands.patch(uiState.view.locale, id, changed).apply(next)
    }
    commit(EditCommand { next }, label)
}
